import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, BankOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const { Title, Text } = Typography;

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            setLoading(true);
            await authService.login(values.username, values.password);
            message.success('Đăng nhập thành công!');
            navigate('/');
        } catch (error) {
            message.error(error.message || 'Đăng nhập thất bại!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Background decoration */}
            <div style={{
                position: 'absolute',
                top: '-50%',
                left: '-50%',
                width: '200%',
                height: '200%',
                background: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
                backgroundSize: '50px 50px',
                animation: 'float 20s ease-in-out infinite',
                zIndex: 1
            }} />
            
            <div style={{
                position: 'absolute',
                top: '10%',
                right: '10%',
                width: '200px',
                height: '200px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '50%',
                animation: 'pulse 4s ease-in-out infinite',
                zIndex: 1
            }} />
            
            <div style={{
                position: 'absolute',
                bottom: '10%',
                left: '10%',
                width: '150px',
                height: '150px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '50%',
                animation: 'pulse 6s ease-in-out infinite',
                zIndex: 1
            }} />

            <Card 
                style={{ 
                    width: 450, 
                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                    borderRadius: '16px',
                    border: 'none',
                    position: 'relative',
                    zIndex: 2,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)'
                }}
                bodyStyle={{ padding: '40px' }}
            >
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    {/* Logo VFI */}
                    <div style={{
                        width: '80px',
                        height: '80px',
                        background: 'linear-gradient(135deg, #1890ff, #722ed1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px',
                        boxShadow: '0 8px 16px rgba(24, 144, 255, 0.3)'
                    }}>
                        <img src={require('../assets/images/logo.png')} alt="VFI" style={{ width: '100%', height: '100%' }} />
                    </div>
                    
                    <Title level={2} style={{ 
                        margin: 0, 
                        color: '#1890ff',
                        fontWeight: 'bold',
                        fontSize: '28px'
                    }}>
                        Quản Lý Nhà Xưởng
                    </Title>
                    
                    <Text style={{ 
                        color: '#8c8c8c',
                        fontSize: '14px'
                    }}>
                        Đăng nhập để tiếp tục
                    </Text>
                </div>
                
                <Form
                    name="login"
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập!' }]}
                    >
                        <Input 
                            prefix={<UserOutlined style={{ color: '#bfbfbf' }} />} 
                            placeholder="Tên đăng nhập"
                            style={{
                                height: '48px',
                                borderRadius: '8px',
                                border: '1px solid #d9d9d9',
                                fontSize: '16px'
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
                            placeholder="Mật khẩu"
                            style={{
                                height: '48px',
                                borderRadius: '8px',
                                border: '1px solid #d9d9d9',
                                fontSize: '16px'
                            }}
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button 
                            type="primary" 
                            htmlType="submit" 
                            loading={loading}
                            style={{ 
                                width: '100%',
                                height: '48px',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                background: 'linear-gradient(135deg, #1890ff, #722ed1)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 16px rgba(24, 144, 255, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 12px rgba(24, 144, 255, 0.3)';
                            }}
                        >
                            Đăng nhập
                        </Button>
                    </Form.Item>
                </Form>

                <div style={{ 
                    textAlign: 'center', 
                    marginTop: '24px',
                    paddingTop: '24px',
                    borderTop: '1px solid #f0f0f0'
                }}>
                    <Text style={{ 
                        color: '#8c8c8c',
                        fontSize: '12px'
                    }}>
                        © 2025 VFI. Tất cả quyền được bảo lưu.
                    </Text>
                </div>
            </Card>

            <style jsx>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-20px) rotate(180deg); }
                }
                
                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 0.1; }
                    50% { transform: scale(1.1); opacity: 0.2; }
                }
            `}</style>
        </div>
    );
};

export default Login; 